import styled, { css } from 'styled-components'

import {
  FitSelector as LMFFitSelector,
  SizeSelector as LMFSizeSelector,
  TypeStyle,
  TypeStyleBodyMicro,
  focusOutline,
} from '@syconium/little-miss-figgy'

import { ColorGroupsSection } from '../../../components/pages/products/ProductPage/DetailsSection/ColorGroupsSection/ColorGroupsSection'

/**
 * Though this styled component contains no styles of its own, it is used as a
 * target by a parent style to apply context-specific style(s):
 */
export const ColorSection = styled.section<{
  showColorSelector?: boolean
}>`
  display: ${o => (o.showColorSelector ? 'block' : 'none')};
`

export const FitSection = styled.section`
  margin-top: 24px;
`

export const ErrorMessageWrapper = styled(TypeStyleBodyMicro)`
  margin-top: ${o => o.theme.spacing(2)};
  color: ${o => o.theme.color.stroke.critical.text.on.subtle};
  display: flex;
  font-weight: 600;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
`

export const SoldOutMessage = styled.span`
  color: ${o => o.theme.color.stroke.critical.text.on.subtle};
  margin-left: ${o => o.theme.spacing(1)};
`

const selectorStyles = css`
  margin-top: 8px;
`

export const ColorSelector = styled(ColorGroupsSection)`
  ${selectorStyles}
` as typeof ColorGroupsSection

export const SizeSectionTopText = styled.div`
  display: flex;
  justify-content: space-between;
`

export const SizeChartButton = styled.span`
  ${TypeStyle.css.headlineMicro};
  font-weight: 600;
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  outline: none;
  text-decoration: underline;

  ${focusOutline}
`

export const SizeSelector = styled(LMFSizeSelector)`
  ${selectorStyles}
  scroll-margin-top: 250px;
`

export const FitSelector = styled(LMFFitSelector)`
  ${selectorStyles}
`

export const SizeSection = styled.section`
  margin-top: 24px;

  &:focus {
    outline-style: solid;
    outline-color: ${o => o.theme.color.effect.focus.outline.on.background};
  }
  ${focusOutline}
`
